export default __webpack_public_path__ + "static/media/property_125.2cccc6ec.png";